export default __webpack_public_path__ + "static/media/forgotpassword.549651e4.png";